<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <label class="search-label">门店</label>
          <Select v-model="factoryId" class="search-input" clearable>
            <Option
              v-for="item in factoryIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
        <Col span="4" class="search-right">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="addModal"
      title="添加职位"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="addChild"
        @on-ok="addSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="editModal"
      title="编辑职位"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="editChild"
        :editData="editData"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./form.vue";
import {
  getUserList,
  getUserInfo,
  addUser,
  delUser,
  editUser,
  updateUserStatus,
  getAllFactory,
  getAllRole,
  getClassifys,
} from "@/api/data";
export default {
  name: "role",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      modalWidth: 600,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      factoryIds: [],
      searchValue: "",
      factoryId: "",
      tableLoading: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        { title: "帐号", key: "username", editable: true },
        { title: "员工编号", key: "code", editable: true },
        // { title: "所属门店", key: "factory_name", editable: true },
        { title: "所属分类", key: "classify_name", editable: true },
        // { title: "员工姓名", key: "real_name", editable: true },
        {
          title: "在职状态",
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("i-switch", {
                props: {
                  type: "primary",
                  value: params.row.status === true,
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  "on-change": (value) => {
                    this.changeUserStatus(value, params);
                  },
                },
              }),
            ]);
          },
        },
        // { title: "手机", key: "phone", editable: true },
        // { title: "邮箱", key: "email", editable: true },
        { title: "入职时间", key: "create_time", editable: true },
        // { title: "离职时间", key: "delete_time", editable: true },
        {
          title: "Handle",
          key: "handle",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    showAddModal() {
      this.addModal = true;
      getAllFactory().then((res) => {
        var factoryList = res.data.data.records;
        this.$refs.addChild.setFactoryData(factoryList);
      });

      getAllRole().then((res) => {
          var roleList = res.data.data.records;
          this.$refs.addChild.setRoleData(roleList);
          this.$refs.addChild.setAddData();
          this.resetFlag = !this.resetFlag;
        });
      getClassifys().then((res) => {
        var classifyList = res.data.data.records;
        this.$refs.addChild.setClassifyData(classifyList);
      });

    },
    showEditModal(params) {
      this.editModal = true;

      getClassifys().then((res) => {
        var classifyList = res.data.data.records;
        // this.$refs.addChild.setFactoryData(classifyList);
        this.$refs.editChild.setClassifyData(classifyList)
      });

      getUserInfo(params.row.id).then((res) => {
          var data = res.data.data;
          var roles = [];
          for (var i = 0; i < data.roles.length; i++) {
            roles[i] = data.roles[i].id;
          }
          data.roles = roles;
          this.$refs.editChild.setEditData(data);
        });

      getAllFactory().then((res) => {
        var factoryList = res.data.data.records;
        this.$refs.editChild.setFactoryData(factoryList);

      });

      getAllRole().then((res) => {
          var roleList = res.data.data.records;
          this.$refs.editChild.setRoleData(roleList);
      });

    },
    addSumit(formValidate) {
      addUser(formValidate)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.handleSearch();
            this.addModal = false;
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      editUser(formValidate)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    changeUserStatus(value, params) {
      let data = new FormData();
      data.append("id", params.row.id);
      data.append("status", value);
      updateUserStatus(data).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success("成功!");
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      getUserList(
        this.page,
        this.pageSize,
        this.searchValue,
        this.factoryId
      ).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    getAllFactory() {
      getAllFactory()
        .then((res) => {
          if (res.data.code == 200) {
            this.factoryIds = res.data.data.records;
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          delUser(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
      // params
      // row
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch()
    this.getAllFactory()
  },
};
</script>
